import Posts from "./../../Components/Posts";
export default function PUB() {
  return (
    <>
      <Posts />
    </>
  );
}
